// `unitId` + `hash` together uniquely identify a showroom resource. `projectSlug` is redundant
// for cache identity (it's derived from the project the unitId resolves to).
export const showroomKeys = {
    root: ['showroom'] as const,
    byUnit: (unitId: number, hash: string) => ['showroom', unitId, hash] as const,
    calculate: (unitId: number, hash: string) => ['showroom', unitId, hash, 'calculate'] as const,
};
